/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import * as palettes from '../../constants/palette';
import * as fonts from '../../constants/fonts';
import * as buttons from '../../constants/buttons';

var TAGThemeProvider = function TAGThemeProvider(_ref) {
  var branding = _ref.branding,
      children = _ref.children;
  var brandPalette = palettes[branding];
  var brandFonts = fonts[branding];
  var brandButtons = buttons[branding];
  var theme = createTheme({
    palette: brandPalette,
    typography: brandFonts,
    components: {
      MuiButton: brandButtons
    }
  });
  return React.createElement(ThemeProvider, {
    theme: theme
  }, children);
};

export default TAGThemeProvider;